module.exports = __webpack_public_path__ + "1792771649312/fonts/Rubik-Regular.0955618.ttf";